export default "__VITE_ASSET__c1a3d586__"